module.exports = __webpack_public_path__ + "static/media/Primary-Arched_solid copy.e084c876.png";